<template>

    <b-card class="mb-2">
      <b-card-text text-tag="div">
        <ValidationObserver ref="form" >
         <b-form @submit.prevent="onSubmit">
          <div class="row">
            <div class="col-md-3">
              <b-form-group
                  id="input-group-hotel"
                  label-for="seller"
                  label="Selecciona un vendedor"
                  :class="getClassState(stateToSeller)+' mb-0'"
                >
              <autocomplete
                  :search="searchSellers"
                  placeholder="Vendedor"
                  aria-label="Vendedor"
                  :state="stateToSeller"
                  :get-result-value="getResultValueSellers"
                  @submit="onSelectSeller"
                ></autocomplete>
                <p>{{seller_msg}}</p>
              </b-form-group>
            </div>
            <div class="col-md-3">
              <ValidationProvider name="folio inicio" rules="required" v-slot="{ validated, valid }">
              <b-form-group
                id="fieldset-1"
                description="Folio inicio"
                label="Desde el Folio:"
                :state="getState(validated, valid)"
                label-for="input-1"
              >
                <b-form-input id="input-1" type="number" v-model="folio_inicio"  trim></b-form-input>
                <p>{{folio_inicio_msg}}</p>
              </b-form-group>
              </ValidationProvider>
            </div>
            <div class="col-md-3">
              <ValidationProvider name="folio final" rules="required" v-slot="{ validated, valid }">
              <b-form-group
                id="fieldset-2"
                description="Folio final"
                label="Hasta el folio:"
                label-for="input-2"
                :state="getState(validated, valid)"
              >
                <b-form-input id="input-2" type="number" 
                v-model="folio_final"  trim></b-form-input>
                <p>{{folio_final_msg}}</p>
              </b-form-group>
              </ValidationProvider>
            </div>
           <div class="col-md-3">
              <b-form-group
                id="fieldset-2"
                description="Total de folios"
                label="Cantidad calculada:"
                label-for="input-2"
              >
                <b-form-input id="input-2" type="number" v-model="total_tickets" readonly trim></b-form-input>
              </b-form-group>
            </div>
          </div>
          <hr>
          <div class="row">
            <div class="col-md-12">
               <b-button @click="onSubmit" class="w-100" block variant="primary">Guardar</b-button>
            </div>
          </div>
         </b-form>
        </ValidationObserver>
      </b-card-text>
    </b-card>
</template>
<script>
  import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
  import { ValidationObserver, ValidationProvider, extend } from "vee-validate";
  export default {
    name: 'AddingTickets',
    components: {FontAwesomeIcon,ValidationObserver, ValidationProvider},
    props:['terminal'],
    data() {
      return {
        total_tickets:0,
        stateToSeller: null,
        seller_msg:'',
        folio_inicio:'',
        folio_final:'',
        folio_inicio_msg: "",
        folio_final_msg: "",
         rRq:{
          name:'',
          email:'',
          total:'',
          seller_id:'',
          currency:'USD',
        }
      }
    },
    watch:{
      folio_inicio(newValue) {
        this.validateTickets(newValue,this.folio_final);
      },
      folio_final(newValue){
        this.validateTickets(this.folio_inicio,newValue);
      },
    },
    methods:{
      onSubmit(e) {
        e.preventDefault()
        this.errors = null
        if(this.isValidToSeller()) {
          this.$refs.form.validate().then((success) => {
            if (success) {
              this.loading = true
              const url = `${process.env.MIX_APP_URL}${this.$prefixPanel}/tickets`
              const data = this.getDataToBook()
              this.$axios.post(url, data).then(rs => {
                if (!rs.data.error) {
                  console.log(rs.data);
                  this.makeToast(rs.data.message,'success')
                  //setTimeout(() => window.location.href = url +'/', 8000);
                  
                } else {
                  this.makeToast(rs.data.error,'danger');
                  this.loading = false
                }
              })
              .catch(error=> {
                if (error.response) {
                  this.errors = error.response.data.errors
                }  else {
                  this.errors = {
                    unexpected: ['Hubo un error por favor contacte al administrador']
                  }
                }
                console.log('error quote', error);
                this.loading = false
              })
            }
          })
        }
      },
      makeToast(text,variant,title = null) {
        this.$bvToast.toast(`${text}`, {
          title:title,
          toaster:'b-toaster-top-full',
          autoHideDelay: 5000,
          variant: variant,
          solid: true
        })
      },
      isValidToSeller() {
        if(this.rRq.seller_id !== '') {
          this.seller_msg = '';
          return this.stateToSeller = true
        } else {
          this.seller_msg = 'No olvides seleccionar un vendedor';
          this.makeToast(this.seller_msg,'danger','Error!!!');
          return this.stateToSeller = false
        }
      },
      validateTickets(initialValue, finalValue){
        if(finalValue != 0){
          if(+finalValue > +initialValue){
            this.total_tickets = (finalValue - initialValue) + 1;
            this.folio_final_msg = '';
          }else{
            this.total_tickets = 0;
            console.log("folio inicio:",initialValue);
            console.log("folio fina:",finalValue);
            this.folio_final_msg = 'El folio final debe ser mayor al folio de inicio';
          }
        }
      },
      getDataToBook() {
        let data = {
          terminal: this.terminal.terminal,
          seller_id: this.rRq.seller_id,
          folio_inicio: this.folio_inicio,
          folio_final: this.folio_final,
          total_tickets: this.total_tickets ,
        }
        return data
      },
      getResultValueSellers(result) {
        return result.name
      },
      onSelectSeller(result) {
        this.rRq.seller_id = result.id
      },
      searchSellers(input) {
        this.$emit('on-search', {input : input})
        return new Promise(resolve => {   
          const url = `${process.env.MIX_APP_URL}/api-feraltar/search-sellers-by-terminal?t=${this.terminal.terminal}&q=${encodeURI(
            input
          )}`
          if (input.length < 3) {
            return resolve([])
          }
          this.$axios.get(url).then(rs => {
            //console.log('data.data', rs.data);
            resolve(rs.data.sellers)
          })
          .catch(error=> {
            console.log('error search sellers', error);
          })
        })
      },
      getClassState(state) {
        if (state === null) {
          return ''
        }
        if (state) {
          return 'valid'
        } else {
          return 'is-invalid'
        }
      },
      getState(validated, valid) {
        if (!validated) {
          return null;
        }
        return valid
      }
    },
    
  }
</script>